import "./src/styles/global.css";
import "./src/styles/fonts.css";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { cloneElement } from "react";
import type { GatsbyBrowser } from "gatsby";
import React from "react";
import { ParallaxLayout } from "./src/layouts/ParallaxLayout";
import { LayoutProvider } from "./src/layouts/LayoutProvider";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <LayoutProvider>{element}</LayoutProvider>;
};

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => {
  if ((element.type as any).Layout === false) {
    return cloneElement(element, props);
  }
  const Layout = (element.type as any).Layout ?? ParallaxLayout;
  return <Layout {...props}>{element}</Layout>;
};
